// src/components/DynamicSetupWizard/WizardNav.tsx
import React from "react";
import { Row, Col, Button } from "reactstrap";
import type { Step } from "store/integrations/types";

interface WizardNavProps {
  stepIndex: number;
  steps: Step[];
  pending: any;
  currentType: string;
  saving: boolean;
  onPrev: () => void;
  onNext: () => void;
  onFinish: () => void;
  finishEnabled?: boolean;
}

export default function WizardNav({
  stepIndex,
  steps,
  pending,
  currentType,
  saving,
  onPrev,
  onNext,
  onFinish,
  finishEnabled = true,
}: WizardNavProps) {
  const atLast = stepIndex === steps.length - 1;
  const disableNext = currentType === "discovery" && !pending;

  return (
    <Row className="mt-4">
      <Col>
        <Button outline disabled={stepIndex === 0} onClick={onPrev}>
          <i className="ri-arrow-left-s-line"></i> Prev
        </Button>
      </Col>
      <Col className="text-end">
        {!atLast ? (
          <Button color="primary" disabled={disableNext} onClick={onNext}>
            Next <i className="ri-arrow-right-s-line"></i>
          </Button>
        ) : (
          <Button
            color="success"
            disabled={saving || !finishEnabled}
            onClick={onFinish}
          >
            {saving ? "Saving…" : "Save & Finish"}
          </Button>
        )}
      </Col>
    </Row>
  );
}
